import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-df007568")

_pushScopeId("data-v-df007568")
const _hoisted_1 = { class: "main__section" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ReqeustResponse = _resolveComponent("ReqeustResponse")

  return (_openBlock(), _createBlock("main", null, [
    _createVNode("section", _hoisted_1, [
      (_ctx.state.id)
        ? (_openBlock(), _createBlock(_component_ReqeustResponse, {
            key: 0,
            id: _ctx.state.id,
            kind: _ctx.RequestKindTypes.SecondOpinion
          }, null, 8, ["id", "kind"]))
        : _createCommentVNode("", true)
    ])
  ]))
})